//
//
//
//
//
//
//
//
//
//

import OverviewTop from 'components/overview/OverviewTop';
import OverviewMain from 'components/overview/OverviewMain';
import OverviewImportStatus from 'components/overview/OverviewImportStatus';
import OverviewErrors from 'components/overview/OverviewErrors';
import OverviewSuccess from 'components/overview/OverviewSuccess';

export default {
	name: 'OverviewPage',
	components: {
		OverviewTop,
		OverviewMain,
		OverviewImportStatus,
		OverviewErrors,
		OverviewSuccess,
	},
};
